<template>
    <div class="side-nav__input-group">
        <SideNavInput placeholder="Tenant Name" v-model="tenantNameSearch">
            <template #placeholder-icon>
                <img src="/images/icons/search.svg" alt="">
            </template>
        </SideNavInput>
        <a class="add-btn">
            <img src="/images/icons/add.svg" alt="Add">
        </a>
    </div>
    <div class="side-nav__input-group">
        <SideNavSelect
            placeholder="Section: All"
            v-model="sectionSelect"
            :options="['Option 1', 'Option 2', 'Option 3', 'Option 4']">
        </SideNavSelect>
    </div>
    <div class="side-nav__input-group">
        <div class="col">
            <SideNavSelect
                placeholder="Category: All"
                v-model="sectionSelect"
                :options="['Option 1', 'Option 2', 'Option 3', 'Option 4']">
            </SideNavSelect>
        </div>
        <div class="col">
            <SideNavSelect
                placeholder="LS.Point: All"
                v-model="sectionSelect"
                :options="['Option 1', 'Option 2', 'Option 3', 'Option 4']">
            </SideNavSelect>
        </div>
    </div>
</template>
<script>
import SideNavInput from "../reusable/SideNavInput.vue";
import SideNavSelect from "../reusable/SideNavSelect.vue";


export default {
    name: "tenant-search-area",
    components: {SideNavSelect, SideNavInput},
    data() {
        return {
            tenantNameSearch: '',
            sectionSelect: ''
        }
    },
    watch: {
        tenantNameSearch: function (val) {

        },
        sectionSelect: function (val) {

        }
    }
}
</script>
